// ABOUTME: Resolves metadata for the plant selected in the Settings URL.
// ABOUTME: Sources country and timezone data from the shared UPM plant collection.
import {UpmPlant, useUpmPlantsContext} from '@hconnect/upm'

import {useUrlParam} from '../../routing'

export const useSettingsPlant = (): UpmPlant => {
  const plantCode = useUrlParam('plantCode')
  const upmPlants = useUpmPlantsContext()

  const upmPlant = upmPlants[plantCode]

  if (!upmPlant) throw new Error('UPM plant data is not available')

  return upmPlant
}
